import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  applications,
  applicationsForm,
  tickets,
  ticketsForm,
  imputHours,
  projectsnav,
  projects,
  projectsForm,
} from "./Reducers";
import imputHoursFormReducer from "../../reducers/imputHoursFormReducer";

export default combineReducers({
  tickets,
  ticketsForm,
  applications,
  applicationsForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  imputHours,
  imputHoursForm: imputHoursFormReducer,
  projectsnav,
  projects,
  projectsForm,
});
